import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import {
  APP_ENVIRONMENT,
  DSN_SENTRY,
  FS_ORGID,
  SENTRY_ORG_SLUG,
} from './config';
import * as Sentry from '@sentry/react';
import { FullStory, init } from '@fullstory/browser';
import { fullStoryIntegration } from '@sentry/fullstory';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: DSN_SENTRY,
    integrations: [
      Sentry.browserTracingIntegration(),
      fullStoryIntegration(SENTRY_ORG_SLUG, { client: FullStory }),
    ],
    release: '1.0.0',
    environment: APP_ENVIRONMENT || 'development',
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && error.name === 'AxiosError') {
        return null;
      }
      return event;
    },
  });
}

init({ orgId: FS_ORGID });

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
